import { Component, OnDestroy, OnInit } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LicensingService } from '../core/licensing/licensing.service';
import { Licence, LicenceStatus } from '../viewmodels/licence';
import { LicensingDialogComponent } from './licensing-dialog.component';

@Component({
  selector: 'hb-licensing',
  templateUrl: './licensing.component.html',
  styleUrls: ['./licensing.component.scss'],
})
export class LicensingComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<boolean> = new Subject();

  public licence: Licence;
  public isValid: boolean;
  public showWarningIcon: boolean = false;

  constructor(
    private licensingService: LicensingService,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private i18NextPipe: I18NextPipe
  ) { }

  ngOnInit() {
    this.licensingService.licence.pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        this.licence = data;
        if (this.licence.localizationKey != null) {
          this.licence.statusMessage = this.i18NextPipe.transform(this.licence.localizationKey);
        }
        this.isValid = this.licence.status === LicenceStatus.Valid;
        if(this.isValid && moment(this.licence.expiryDate).isValid()) {
          this.checkLicenseExpiryDays();
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }
  
  public checkLicenseExpiryDays() {
    this.showWarningIcon = this.licensingService.getLicenseExpiryDays() <= 30;
  }

  public showLicenceDialog() {
    this.bsModalRef = this.modalService.show(LicensingDialogComponent);
  }
}
